/**
 * Tells a mounted view that the user opened it again.
 *
 * Keep-alive leaves the document mounted, so becoming visible is not the only
 * "open". The workbench fires this on every open; the surface applies a staged
 * update and reloads the document when one landed.
 */
type ViewOpenedListener = (viewId: string) => void;

const listeners = new Set<ViewOpenedListener>();

export function notifyViewOpened(viewId: string): void {
  for (const listener of listeners) {
    listener(viewId);
  }
}

export function subscribeViewOpened(listener: ViewOpenedListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
